class CollectionCard extends HTMLElement {
	constructor() {
		super()
		this.video = this.querySelector('.collection-card__video')
		this.isDesktop = window.innerWidth >= 768
		this._pauseTimeout = null // Track pending pause

		if (!this.video) return

		// Ensure smooth playback
		this.video.preload = 'auto'
		this.video.muted = true
		this.video.playsInline = true

		if (this.isDesktop) {
			this.addEventListener('mouseenter', () => this.playVideo())
			this.addEventListener('mouseleave', () => this.schedulePause())
		}
	}

	playVideo() {
		// Cancel any pending pause when hovering again
		if (this._pauseTimeout) {
			clearTimeout(this._pauseTimeout)
			this._pauseTimeout = null
		}

		// Play only if not already playing
		if (this.video.paused) {
			this.video.play().catch(() => {
				// Silently fail on autoplay blocked
			})
		}
	}

	schedulePause() {
		// Clear any existing timeout
		if (this._pauseTimeout) {
			clearTimeout(this._pauseTimeout)
		}

		// Pause after 1 second delay
		this._pauseTimeout = setTimeout(() => {
			if (this.video && !this.video.paused) {
				this.video.pause()
				this.video.currentTime = 0 // Reset for instant replay on next hover
			}
			this._pauseTimeout = null
		}, 1000)
	}

	// Clean up timeout on disconnect
	disconnectedCallback() {
		if (this._pauseTimeout) {
			clearTimeout(this._pauseTimeout)
			this._pauseTimeout = null
		}
	}
}

customElements.define('collection-card', CollectionCard)
